import React from "react";

import ReqActionBar from "../common/ReqActionBar";
import GiftDetail from "./GiftDetail"

const GiftDetailComp = (props)=>{

    return(
        <div className="panel">
            <div className="panel-header">
                <div className="panel-header-label">Gifts & Entertainment Request Details</div>
                {props.data.createdTimeStampUserTz && <div>Created : {props.data.createdTimeStampUserTz}</div>}
                {props.data.lastAction !== "Pending" && <div className="ml-4">{props.data.lastAction} : {props.data.updatedTimeStampUserTz}</div>}
            </div>

            <GiftDetail data={props.data} mode="DETAIL"/>

            <ReqActionBar
                reqId={props.data.id}
                reqType="GIFT"
                reqStatus={props.data.status}
                reloadItem={props.reloadItem}
                handleUpdate={props.handleUpdate}
                handleClose={props.handleClose}
            />
            

        </div>
    );
};


export default GiftDetailComp;